import { AgmCoreModule } from '@agm/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSortModule } from '@angular/material/sort';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConstants } from './app.constants';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AlertComponent } from './main/alert/alert.component';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { LoginModel } from './login/loginModel';
import { ChartsModule } from 'ng2-charts';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxMaskModule } from 'ngx-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularFirestore, AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AuthenticationService } from "./firebase/authentication.service";
import { SignalRService } from "./services/signalr.service";
import { environment } from '../environments/environment';
import { ChatService } from './services/chat.service';
import { DataService } from './services/data.service';
import { FunctionsService } from './services/functions.service';
import { MainModule } from './main/main.module';
import { GenericComponentsModule } from './generic-components/generic-components.module';
import { NotificationModel } from './main/notification/notificationModel';
import { PaginationModel } from './models/paginationModel';
import { GroupModel } from './main/settings/group-management/groupModel';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxPermissionsModule, NgxPermissionsService, NgxPermissionsStore, NgxPermissionsConfigurationStore, NgxRolesStore, NgxPermissionsDirective } from 'ngx-permissions';
import { getPaginatorIntl } from './paginator-intl';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxStripeModule } from '@nomadreservations/ngx-stripe';
import { AccountOwnerModule } from './main/account-owner/account-owner.module';
import { UserManagementModule } from './main/user-management/user-management.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SettingsModule } from './main/settings/settings.module';
import { MyInterceptor } from './interceptors/http-interceptor.service';
import { AlertHistoryModule } from './main/alert-history/alert-history.module';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { NotificationModule } from './main/notification/notification.module';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { AlertModule } from './main/alert/alert.module';
import { AgmOverlays } from 'agm-overlays';
import { SharedModule } from './shared/shared.module';
import { AlertLogModule } from "./alert-log/alert-log.module";
import { LoginModule } from './login/login.module';
import { PasswordModule } from './password.module';
import { AccountModule } from './main/account/account.module';
import { AccessibilityStatementModule } from './accessibilityStatement/accessibility-statement/accessibility-statement.module';
import { PrivacyPolicyModule } from './privacyPolicy/privacy-policy/privacy-policy.module';
import { TermsServiceModule } from './termsService/terms-service/terms-service.module';
// import { RegisterModule } from './register/register.module';
import { ForgotPasswordModule } from './forgot-password/forgot-password.module';
import { AuthInterceptorProvider } from './services/token/token-interceptor.service';
import { TokenService } from './services/token/token.service';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        AccessibilityStatementModule,
        PrivacyPolicyModule,
        TermsServiceModule,
        AccountModule,
        PasswordModule,
        LoginModule,
        // RegisterModule,
        ForgotPasswordModule,
        AlertLogModule,
        NotificationModule,
        SettingsModule,
        UserManagementModule,
        AccountOwnerModule,
        AlertModule,
        AlertHistoryModule,
        BreadcrumbModule,
        BrowserModule,
        HttpClientModule,
        ChartsModule,
        MatInputModule,
        MatProgressSpinnerModule,
        FormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatIconModule,
        MatNativeDateModule,
        MainModule,
        NgMultiSelectDropDownModule,
        NgxChartsModule,
        NgxSpinnerModule,
        FormsModule,
        ReactiveFormsModule,
        NgxStripeModule.forRoot(environment.stripe_pk),
        AgmOverlays,
        AgmCoreModule.forRoot({
            apiKey: environment.firebaseConfig.apiKey
        }),
        NgxMaskModule.forRoot(),
        NgbModule,
        MatTableModule,
        MatPaginatorModule,
        MatTabsModule,
        MatSortModule,
        NgxPermissionsModule.forChild(),
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFirestoreModule,
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        GenericComponentsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        PdfViewerModule,
        SelectDropDownModule,
        SharedModule
    ],
    providers: [NgxPermissionsDirective, NgxPermissionsService, NgxPermissionsStore, NgxPermissionsConfigurationStore, NgxRolesStore, AlertComponent, AngularFirestore, AppConstants, AuthenticationService, ChatService, GroupModel, LoginModel, { provide: MatPaginatorIntl, useValue: getPaginatorIntl() }, NotificationModel, PaginationModel, SignalRService, FunctionsService, DataService, MyInterceptor, TokenService, AuthInterceptorProvider,],
    bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}